import React from 'react';
import { sectionHeaderStyle, statusBadgeStyle } from './styles';

interface ConnectionStatusProps {
  isConnected: boolean;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ isConnected }) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Connection Status</div>
      <div style={{ marginBottom: '15px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
          <span>Server:</span>
          <span style={statusBadgeStyle(isConnected)}>
            {isConnected ? '🟢 Connected' : '🔴 Disconnected'}
          </span>
        </div>
        <div style={{ fontSize: '11px', color: '#888', marginBottom: '10px' }}>
          {isConnected
            ? 'Real-time multiplayer sync is active'
            : 'Running in offline / single-player mode'}
        </div>
      </div>
    </>
  );
};
